import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Router } from '@angular/router';
import { CurrentSubject } from '@shared/helpers/current.subject';
import { Patient } from '@shared/models/patient.model';
import { PathologyType } from '@shared/models/pathology.enum';
import { DrugType } from '@shared/models/drug.enum';
import { Observable, debounceTime } from 'rxjs';
import { UtilService } from './util.service';
import { Drug } from '@shared/models/drug.model';

@Injectable()
export class StoreService {
  private init = false;
  //private commentsSubscribe
  private patientDataSubject = new CurrentSubject<Array<Patient>>();
  private pathologyDataSubject = new CurrentSubject<{ [key: string]: PathologyType }>();
  private drugDataSubject = new CurrentSubject<{ [key: string]: DrugType }>();
  private drugATCDataSubject = new CurrentSubject<{ [key: string]: Drug }>();

  constructor(
    private utilService: UtilService,
    private socket: Socket,
    private router: Router
  ) {
    this.utilService.getReady().subscribe(ready => {
      if (ready && !this.init) {
        console.log('store init');
        this.init = true;
        this.storeInit();
      }
    });
  }

  storeInit(): void {
    this.socket.on('GetPatientData', (data: Array<Patient>) => {
      this.patientDataSubject.set(data);
    });
    this.socket.on('GetPathologyData', (data: { [key: string]: PathologyType }) => {
      this.pathologyDataSubject.set(data);
    });
    this.socket.on('GetDrugData', (data: { [key: string]: DrugType }) => {
      this.drugDataSubject.set(data);
    });
    this.socket.on('GetDrugATCData', (data: { [key: string]: Drug }) => {
      this.drugATCDataSubject.set(data);
    });
  }

  requestSocket(field: string, option?: number | Array<number>): void {
    if (this.init) {
      this.socket.emit(field, option);
    } else {
      this.utilService.getReady().subscribe(() => {
        this.socket.emit(field, option);
      });
    }
  }

  secureRequestSocket(field: string, option?: number): void {
    if (this.init) {
      const password = localStorage.getItem('password');
      // if (password) {
      this.socket.emit(field, password, option);
      // }
    } else {
      this.utilService.getReady().subscribe(ready => {
        const password = localStorage.getItem('password');
        // if (password) {
        this.socket.emit(field, password, option);
        // }
      });
    }
  }

  getPatientData(): Observable<Array<Patient>> {
    return this.patientDataSubject.asObservable().pipe(debounceTime(0));
  }

  getPathologyData(): Observable<{ [key: string]: PathologyType }> {
    return this.pathologyDataSubject.asObservable().pipe(debounceTime(0));
  }

  getDrugData(): Observable<{ [key: string]: DrugType }> {
    return this.drugDataSubject.asObservable().pipe(debounceTime(0));
  }

  getDrugATCData(): Observable<{ [key: string]: Drug }> {
    return this.drugATCDataSubject.asObservable().pipe(debounceTime(0));
  }
}
